<template>
  <div
    id="assistant-step-1"
    class="assistant-forms">
    <h2 class="title">General info and preferences</h2>
    <p class="subtitle">Provide general information and preferences for your AI assistant.</p>

    <JsonSchema
      ref="jsonSchema"
      v-model="value"
      :schema="schema | processSchema"
      :components="componentsConfig"
      :ui-schema="uiSchema"
      :wrapper="wrapperComponentConfig"
      @init-default="initDefault"
      @input="() => {}" />

    <!-- <div> dataModel </div> -->
    <!-- <pre class="debug"> {{ value }} </pre> -->
  </div>
</template>

<script>
// TODO
//   - check this code before publishing Assistants feature
//   - enable response data to be flattened

import JsonSchema from '@roma219/vue-jsonschema-form';
import { debounce } from 'debounce';

import SBIconList from '@/helpers/lists/sb-icon-list';
import ToasterMixin from '../../../mixins/Toaster';

const image = require('@/assets/img/icons/assistant-avatars/av-2.svg'); // this is local image example.

export default {
  name: 'AssistantStep1',
  components: {
    JsonSchema,
  },
  mixins: [ToasterMixin],
  data() {
    return {
      initialized: false,
      steps: 4,
      currentStep: 1,
      initializedSteps: [],
      value: {},
      // stepImage: 'https://sendbee-media-prod.s3.eu-west-1.amazonaws.com/icons/trigger_delay_gray.svg',
      stepImage: image,
      // uiSchema: {
      //   bio: {
      //     'ui:options': {
      //       placeholder: 'Please enter your bio.',
      //       type: 'textarea',
      //       rows: 1,
      //     },
      //   },
      // },
      // uiSchema: {
      //   properties: {
      //     text: {
      //       uiType: 'b-input',
      //     },
      //   },
      // },
      componentsConfig: [
        {
          componentName: 'BInputWrapper',
          uiSchemaMatcher: { uiType: 'BInputWrapper' },
          // eventName: 'changeInput',
          props: (propName, schema, uiSchema) => {
            // console.log('propName', propName);
            // console.log('schema', schema);
            // console.log('uiSchema', uiSchema);
            return {
              'full-width': true,
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              placeholder: schema.placeholder,
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'SBTextareaWrapper',
          uiSchemaMatcher: { uiType: 'SBTextareaWrapper' },
          // eventName: 'changeInput',
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': true,
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              placeholder: schema.placeholder,
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'SBDropdownWrapper',
          uiSchemaMatcher: { uiType: 'SBDropdownWrapper' },
          // eventName: 'changeInput',
          props: (propName, schema, uiSchema) => {
            // console.log('DROPDOWN');
            // console.log(uiSchema);
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              placeholder: schema.placeholder,
              validators: schema.validators,
              required: schema.validators ? schema.validators.split('|').includes('required') : false,
              schema,
              // 'ui-schema': uiSchema,
            };
          },
        },
        {
          componentName: 'NMBRButtonsWrapper',
          uiSchemaMatcher: { uiType: 'NMBRButtonsWrapper' },
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': true,
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              placeholder: schema.placeholder,
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'DividerWrapper',
          // uiSchemaMatcher: { uiType: 'DividerWrapper' },
          matcher: { type: 'dividerFull' },
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': true,
              schema,
            };
          },
        },
        {
          componentName: 'DividerWrapper',
          // uiSchemaMatcher: { uiType: 'DividerWrapper' },           // IMPORTANT: maybe uiSchema is not needed
          matcher: { type: 'divider' },
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': false,
              schema,
            };
          },
        },
        {
          componentName: 'DurationWrapper',
          matcher: { type: 'duration' },
          props: (propName, schema, uiSchema) => {
            return {
              validators: schema.validators,
              // value: schema.value,                                   // NOTE: the Number value can't be accepted. It needs object that we need to standardize.
              minSeconds: schema.minSeconds,
              minSecondsMessage: schema.minSecondsMessage,
              maxSeconds: schema.maxSeconds,
              maxSecondsMessage: schema.maxSecondsMessage,
              schema,
            };
          },
        },
      ],
      wrapperComponentConfig: {
        componentName: 'SBCustomWrapperJSONForms',
        props: (propName, schema, uiSchema) => ({
          title: schema.title || schema.title === '' ? schema.title : '',
          required: schema.validators ? schema.validators.split('|').includes('required') : false,
          disabled: uiSchema && uiSchema.disabled,
          errorMessage: schema.errorMessage,
          vertical: schema.type === 'object' || schema.type === 'array',
          schema,
        }),
      },
    };
  },
  computed: {
    schema() {
      return {
        type: 'object',
        properties: {
          name: {
            type: 'input',
            returnKey: 'name-test',
            returnProperties: ['value', 'group', 'variableName', 'valueType'],
            group: 'foobar',
            variableName: 'business_name',
            valueType: 'string',
            title: 'Name',
            pickIcon: true,
            // focus: true,
            placeholder: 'Support assistant',
            errorMessage: 'Schema error message',
            validators: 'required|maxLength:100',
            subtitlePrefixIcon: SBIconList.EYE_CLOSED_FILL,
            subtitle: 'Only visible to team members in your AI Number account.',
            iconList: [],
          },
          businessName: {
            value: '',
            returnKey: 'name-handoff',
            group: 'handoff', // ........ GROUPS TODO
            type: 'input',
            title: 'Business name',
            placeholder: 'Super Company Inc.',
            errorMessage: 'Schema error message',
            validators: 'required|maxLength:100',
            warningValidators: 'minLength',
            validatorMessages: {
              minLength: 'Add descriptive info to improve the AI\'s responses.',
              maxLength: null,
            },
            subtitlePrefixIcon: SBIconList.INFO,
            subtitle: 'Add the business the AI works for.',
          },
          responsibility: {
            type: 'input',
            title: 'Responsibility',
            placeholder: 'Provide customer support',
            errorMessage: 'Schema error message',
            validators: 'required|minLength:20|maxLength:100',
            warningValidators: 'minLength',
            subtitlePrefixIcon: SBIconList.INFO,
            subtitle: 'Add the responsibility the AI will perform.',
          },
          language: {
            value: 'fr',
            type: 'dropdown',
            title: 'Language',
            placeholder: 'Select language',
            validators: 'required',
            subtitlePrefixIcon: SBIconList.INFO,
            subtitle: 'AI will reply in {{ option }}.',
            subtitlePlaceholderDefault: 'the contact\'s language',
            options: [
              { value: 'en', label: 'English',
              // image: 'https://flagcdn.com/us.svg'
              },
              { value: 'es', label: 'Spanish',
              // image: 'https://flagcdn.com/es.svg'
              },
              { value: 'fr', label: 'French',
              // image: 'https://flagcdn.com/fr.svg
              },
              // { value: 'es', label: 'Spanish' },
              // { value: 'fr', label: 'French' },
            ],
            width: 50,
          },
          // tone: {
          //   type: 'dropdown',
          //   title: 'Conversation tone',
          //   placeholder: 'Select tone',
          //   validators: 'required',
          //   subtitlePrefixIcon: SBIconList.INFO,
          //   subtitle: 'AI will use {{ option:lowercase }} tone in replies.', // lowercase, uppercase, capitalize
          //   options: [
          //     { value: 'standard', label: 'Standard' },
          //     { value: 'man', label: 'Man' },
          //     { value: 'woman', label: 'Woman' },
          //   ],
          //   width: 50,
          // },
          currencyFormat: {
            type: 'dropdown',
            title: 'Currency format',
            placeholder: 'USD ($100,00.00)',
            options: [
              { value: 'USD', label: 'USD ($100,00.00)' },
              { value: 'CAD', label: 'CAD (100,00.00$)' },
              { value: 'HR', label: 'HR (100,00.00€)' },
            ],
            width: 50,
            subtitlePrefixIcon: SBIconList.INFO,
            subtitle: 'Select the format that AI will use in replies.',
          },
          message: {
            type: 'textarea',
            title: 'Intro message',
            placeholder: 'Hello, thanks for reaching out. How can we help you today?',
            validators: 'maxLength:1024',
            subtitleTopPrefixIcon: SBIconList.INFO,
            subtitleTop: 'AI will start a conversation with this message.',
          },
          buttons: {
            value: [
              // { title: 'Help', fixed: true },
              // { title: 'Contact us' },
            ],
            type: 'message-buttons',
            addButtonIcon: SBIconList.PLUS,
            addButtonText: 'Add button',
            // buttonMaxTextLength: 25,
            // maxTextPreventInput: false,
            minButtons: 0,
            maxButtons: 10,
            enter: 'Add',
            child: true,
            returnKey: 'buttonsList',
            validators: 'required|maxLength:20',
            validatorMessages: {
              required: 'Button text is required.',          // Set this to prevent unwanted default messages
              maxLength: 'Please limit your text to {{validator}} characters.',      // Placeholders must be named as the validator name and vill be replaced with the value.
            },
          },
          // duration: {
          //   type: 'duration',
          //   // value: 360,
          //   hideScopes: ['dAYs'],
          //   minSeconds: 420,
          //   minSecondsMessage: 'Retrigger period can\'t be less than 7 minutes.',
          //   maxSeconds: 600,
          //   maxSecondsMessage: 'Retrigger period can\'t exceed 10 minutes.',
          // },
        },
      };
    },
    /** Schema needs to be proccesed because some inputs can take less than 100% width and according to the number of elements in a row the appropriate  */
    // proccessedSchema() {
    //   return this.schema;
    // },
    uiSchema() {
      const uiSchema = {
        properties: {},
      };
      Object.keys(this.schema.properties).forEach((prop) => {
        switch (this.schema.properties[prop].type) {
          case 'input':
            uiSchema.properties[prop] = {
              uiType: 'BInputWrapper',
            };
            break;
          case 'textarea':
            uiSchema.properties[prop] = {
              uiType: 'SBTextareaWrapper',
            };
            break;
          case 'dropdown':
            uiSchema.properties[prop] = {
              uiType: 'SBDropdownWrapper',
            };
            break;
          case 'message-buttons':
            uiSchema.properties[prop] = {
              uiType: 'NMBRButtonsWrapper',
            };
            break;
          case 'dividerFull':
            uiSchema.properties[prop] = {
              uiType: 'DividerWrapper',
            };
            break;
          case 'number':
            // uiSchema.properties[prop] = {
            //   uiType: 'b-input',
            // };
            break;
          case 'boolean':
            // uiSchema.properties[prop] = {
            //   uiType: 'b-input',
            // };
            break;
          default:
            break;
        }
      });
      // console.log('uiSchema', uiSchema);
      return uiSchema;
    },
  },
  watch: {
    value: {
      handler() {
        // console.log('value', this.value);
        // console.log('checkData valid', (!this.$refs.jsonSchema.$v.$invalid).toString());
        this.$nextTick(() => {
          this.checkData();
        });
      },
      deep: true,
    },
  },
  updated() {
    this.stepUpdate();
  },
  mounted() {
    window.eventBus.$on('assistantStepsInit', this.stepInit);
  },
  methods: {
    stepInit(data) {
      this.initializedSteps.push(data.step);
      if (this.initializedSteps.length === this.steps) {
        this.focusFirstInput();
      }
    },
    stepUpdate: debounce(function f() {
      if (!this.initialized) {
        window.eventBus.$emit('assistantStepsInit', { step: 1 });
        this.initialized = true;
      }
    }, 100),
    focusFirstInput() {
      if (this.currentStep === 1) {
        // Find first input field and focus it
        const input = document.getElementById('assistant-step-1').querySelector('input, .ql-editor');
        if (input) input.focus();
      }
    },
    checkData() {
      // console.log('VALIDATED');
      // console.log('checkData', this.value);
      // console.log('checkData valid', (!this.$refs.jsonSchema.$v.$invalid).toString());

      // CUSTOM validations
      let componentsValid = true;
      Object.keys(this.value).some((component) => {
        // console.log('component', component);
        if (this.value[component] && this.value[component].valid === false) {
          // console.log('component false', component);
          componentsValid = false;
          return true;
        }
        return false;
      });

      this.$emit('input', {
        valid: componentsValid,
        name: 'assistantStep1',
        data: this.value,
      });
    },
    initDefault(v) {
      this.value = v;
    },
  },
};
</script>

<style scoped>
h1 {
  color: #42b983;
}
</style>
